import type ModalConversationService from '../../../modals/modal-conversation.service';
import type {StaticSearchParams} from 'typings/portaro.be.types';
import {transferify} from '../../utils/data-service-utils';
import type {SvelteComponentConstructor} from 'core/types';
import type { SearchSelectionModalModel } from 'src/modals/search-selection-modal/types';
import type {SelectableItem} from '../../../modals/search-selection-modal/types';

export default class SearchableValueEditorService {
    public static readonly serviceName = 'searchableValueEditorService';

    /*@ngInject*/
    constructor(private modalConversationService: ModalConversationService) {
    }

    public async searchAndSelectItem<MODEL>(notTransferifiedStaticSearchParams: StaticSearchParams, customComponent?: SvelteComponentConstructor<{value: SelectableItem, isSelected?: boolean}>): Promise<MODEL> {
        const modalModel: SearchSelectionModalModel = {
            staticSearchParams: transferify(notTransferifiedStaticSearchParams),
            customComponent
        };
        return this.modalConversationService.searchItem<MODEL>(modalModel);
    }
}